export const MODE_ORDER_NUMBER = 'order_number'
export const MODE_ORDER_ID = 'order_id'

export const DELIVERY_DELIVERED = 'delivered'
export const DELIVERY_NOT_DELIVERED = 'not_delivered'
export const DELIVERY_UNKNOWN = 'unknown'

export const ERROR_NATURA_REFUSED = 'natura_refused'
export const ERROR_NATURA_NO_RESPONSE = 'natura_no_response'
export const ERROR_NATURA_AUTH_FAILED = 'natura_auth_failed'
export const ERROR_AMBIGUOUS_ORDER_NUMBER = 'ambiguous_order_number'
export const ERROR_RESEND_IN_PROGRESS = 'resend_in_progress'
export const ERROR_PAYLOAD_BUILD_FAILED = 'payload_build_failed'
export const ERROR_INTEGRATION_UNUSABLE = 'integration_unusable'
export const ERROR_PAYLOAD_CHANGED = 'payload_changed'
export const ERROR_UNKNOWN_DELIV_ITEMS = 'unknown_deliv_items'
export const ERROR_EMPTY_PAYLOAD = 'empty_payload'

// These come back on a 502 carrying the full round trip, so they render as a
// result rather than as a failure — the round trip is what ops came for.
export const NATURA_OUTCOME_ERRORS = [ERROR_NATURA_REFUSED, ERROR_NATURA_NO_RESPONSE, ERROR_NATURA_AUTH_FAILED]

// The platform's own message is the diagnostic for these, so it is shown verbatim
// under the translated headline instead of being swallowed. payload_build_failed
// carries the builder's reason — a partial ship, a missing lot — which is the answer.
export const ERRORS_WITH_RAW_DETAIL = [ERROR_PAYLOAD_BUILD_FAILED, ERROR_INTEGRATION_UNUSABLE]

// Every rejection code the platform can answer with. Anything outside this list
// falls back to the generic panel rather than rendering an untranslated string.
export const KNOWN_REJECTIONS = [
  'order_not_found',
  'missing_identifier',
  'not_natura_order',
  'qa_store_skipped',
  'lock_unavailable',
  'circuit_open',
  ERROR_AMBIGUOUS_ORDER_NUMBER,
  ERROR_RESEND_IN_PROGRESS,
  ERROR_PAYLOAD_BUILD_FAILED,
  ERROR_INTEGRATION_UNUSABLE,
  ERROR_PAYLOAD_CHANGED,
  ERROR_UNKNOWN_DELIV_ITEMS,
  ERROR_EMPTY_PAYLOAD,
  'invalid_added_entry',
  'unknown_sku',
  'free_line_not_supported',
]

// DELIV_ITEM travels padded to 6, and the platform pads what it receives — padding here too
// keeps "30" and "000030" from reading as two different lines on screen.
export const padDelivItem = value => {
  const trimmed = String(value ?? '').trim()
  return /^\d{1,6}$/.test(trimmed) ? trimmed.padStart(6, '0') : trimmed
}

// The builder emits one entry per (order_line, lot), so several entries can share a
// DELIV_ITEM. Selection and removal are per line number, never per entry.
export const groupByDelivItem = (entries = []) => {
  const order = []
  const groups = {}

  entries.forEach(entry => {
    const key = entry.deliv_item
    if (!groups[key]) {
      groups[key] = []
      order.push(key)
    }
    groups[key].push(entry)
  })

  return order.map(key => ({ delivItem: key, entries: groups[key] }))
}

// Two lots of one line can legitimately be corrected to the same SKU and lot — that is the
// consolidation case. The platform dedupes identical entries as a double submit, so rows that
// became identical are sent once carrying both quantities; two rows would collapse into one and
// confirm the line short. A non-numeric quantity is left alone: it is the platform's to refuse,
// and summing it would hide which row was wrong.
const WHOLE_NUMBER = /^\d+$/

export const mergeCorrections = (lines = []) =>
  lines.reduce((merged, line) => {
    const entry = {
      deliv_item: padDelivItem(line.deliv_item),
      sku: String(line.sku ?? '').trim(),
      batch: String(line.batch ?? '').trim(),
      dlv_qty: String(line.dlv_qty ?? '').trim(),
    }

    const twin =
      WHOLE_NUMBER.test(entry.dlv_qty) &&
      merged.find(
        candidate =>
          candidate.deliv_item === entry.deliv_item && candidate.sku === entry.sku && candidate.batch === entry.batch && WHOLE_NUMBER.test(candidate.dlv_qty),
      )

    if (twin) {
      twin.dlv_qty = String(Number(twin.dlv_qty) + Number(entry.dlv_qty))
      return merged
    }

    return [...merged, entry]
  }, [])
